import styled from 'styled-components';

export const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgba(70, 74, 255,0.8);
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
  height: 100vh;
  text-align: left;
  padding: 2rem 3rem 2rem 7rem;
  position: fixed;
  top: 0;
  right: 0;
  transition: transform 0.3s ease-in-out;
  z-index:5;

  @media (max-width: ${({ theme }) => theme.mobile}) {
      width: 100%;
    }

  a {
    font-size: 1.5rem;
    padding: 1rem 0;
    font-weight: bold;
    letter-spacing: 0.5rem;
    color: ${({ theme }) => theme.gris};
    text-decoration: none;
    transition: color 0.3s linear;
    text-align: end;

    @media (max-width: ${({ theme }) => theme.mobile}) {
      font-size: 1.5rem;
      text-align: center;
    }

    &:hover {
      color: ${({ theme }) => theme.white};
    }
  }
`;

export const StyledFondoMenu = styled.div`
  
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
  background: rgba(24, 30, 32, 0.62);
  position: fixed;
  z-index: 4;
  width: 100% !important;
  height: 100vh;
`;
